// extracted by mini-css-extract-plugin
export default {"faqSection":"FAQSection_faqSection__3D8PM","faqGrid":"FAQSection_faqGrid__5hz1P","faqItem":"FAQSection_faqItem__9+Xkm","fadeIn":"FAQSection_fadeIn__yjxkF"};